import { useDispatch } from 'react-redux';
import { $api } from '@service/RequestService';
import { timeStampToDate } from '@utils/index';
import { useQuery } from 'react-query';
import { ArrayParam, NumberParam, NumericArrayParam, StringParam, useQueryParams, withDefault } from 'use-query-params';

import { realtorBookingConstants, realtorBookingModels, setRealtorBookingTotalItems } from '..';

export function useRealtorBookings() {
  const dispatch = useDispatch();

  const initial = {
    bookings: [],
    totalPages: 0,
    currentPage: 1,
    totalElements: 0
  };

  const [query] = useQueryParams({
    search: StringParam,
    page: withDefault(NumberParam, 1),
    size: withDefault(NumberParam, 10),
    startDate: StringParam,
    finishDate: StringParam,
    realtors: NumericArrayParam,
    houses: NumericArrayParam,
    buildings: NumericArrayParam,
    companies: NumericArrayParam,
    actions: ArrayParam
  });

  const { data = initial, ...arg } = useQuery<{
    bookings: realtorBookingModels.RealtorBookingType[];
    totalPages: number;
    currentPage: number;
    totalElements: number;
  }>([realtorBookingConstants.queryKeys.BOOKINGS, query], async () => {
    const { data } = await $api.post('/v1/realtor-booking/filter', query);

    const totalPages = data?.data?.totalPages || 0;
    const currentPage = data?.data?.currentPage || 1;
    const totalElements = data?.data?.totalElements || 0;

    dispatch(setRealtorBookingTotalItems({ totalElements, totalPages }));

    const bookings = (data?.data?.data as realtorBookingModels.RealtorBookingType[])?.map(item => ({
      ...item,
      createdDate: timeStampToDate({ date: item?.createdDate, timeStamp: item?.createdTimestamp })
    }))

    return {
      bookings: bookings ? bookings : data?.data?.data,
      totalPages,
      totalElements,
      currentPage
    };
  });

  return { ...data, ...arg };
}
